import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="14" height="11" viewBox="0 0 14 11" fill="#F1281B" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.299.596a.624.624 0 01.882.883l-8.826 8.826-.003.002-.002.002a.624.624 0 01-.882 0L.82 7.662a.624.624 0 01.882-.883L3.91 8.986l8.39-8.39z" /></svg>);